import { render, staticRenderFns } from "./CXRecord.vue?vue&type=template&id=28dd6062&scoped=true&"
import script from "./CXRecord.vue?vue&type=script&lang=js&"
export * from "./CXRecord.vue?vue&type=script&lang=js&"
import style0 from "./CXRecord.vue?vue&type=style&index=0&id=28dd6062&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dd6062",
  null
  
)

export default component.exports